
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexiaycEQxP4k38L0j_mwh1zNjsJEdUGVNQldVtujD_Qa4Meta } from "/home/runner/work/tensormap/tensormap/pages/index.vue?macro=true";
import { default as index8kq1bWfI4kbPXv5E0K6hXZHwx9Dlp4uw_ZRZ8V6ROXsMeta } from "/home/runner/work/tensormap/tensormap/pages/profile/index.vue?macro=true";
import { default as change_45passwordC1kjc8etczW91iMbQbFANh2MofAAJzFa_4547vA7lyLsAMeta } from "/home/runner/work/tensormap/tensormap/pages/profile/change-password.vue?macro=true";
import { default as profile30kRQMklTyqvFcO2IkudJDu2EoHmi7Nxl5BcIp3Q_TQMeta } from "/home/runner/work/tensormap/tensormap/pages/profile.vue?macro=true";
import { default as indexhT5QoMrCeoupcFwmQmeHJP_GPoQ9RGVPprA1E9MQSpsMeta } from "/home/runner/work/tensormap/tensormap/pages/admin/index.vue?macro=true";
import { default as confirm_45otp7uwyj_45yeO2ML3w5lWqngOpPsrluaBpheuXRKxaWT6sMMeta } from "/home/runner/work/tensormap/tensormap/pages/confirm-otp.vue?macro=true";
import { default as manage_45cardsFdtfXPXG1_45C8zCey58ncZKA85jl3axGYySBqqVUeQFAMeta } from "/home/runner/work/tensormap/tensormap/pages/manage-cards.vue?macro=true";
import { default as index_45xS5sGLFdO2nZRyaocBzA5FPp_VpHoGr_E7DQDIASIgMeta } from "/home/runner/work/tensormap/tensormap/pages/signup/index.vue?macro=true";
import { default as indexaQtloG4xKf6TZf1b2ORz6V7y0mwSb3MbcvfEClihiXUMeta } from "/home/runner/work/tensormap/tensormap/pages/surveys/index.vue?macro=true";
import { default as _91action_93LrqPVpnNZ40Rx8_455m2fwfPqcoQgzmt04RydehGrjrH0Meta } from "/home/runner/work/tensormap/tensormap/pages/test/[action].vue?macro=true";
import { default as _91action_93t_fKZZ2NTTJTKiZxU9GyUslxeYzBFtvI7CbYBcy4dVwMeta } from "/home/runner/work/tensormap/tensormap/pages/admin/[action].vue?macro=true";
import { default as privacy_45policyMRFmwy8_3clkPvcQHJOFC_Hwn1L7uQM7xOnKVUFylhgMeta } from "/home/runner/work/tensormap/tensormap/pages/privacy-policy.vue?macro=true";
import { default as indexzttKiiUSXp6G5fv1YpogKmCTePULR6U54_45RDQi_45ucDQMeta } from "/home/runner/work/tensormap/tensormap/pages/products/index.vue?macro=true";
import { default as forgot_45passwordM_45XYKIVuQeS5iBmTvk0djwkg1VAKKbMit3EH0pQrFEsMeta } from "/home/runner/work/tensormap/tensormap/pages/forgot-password.vue?macro=true";
import { default as indexbv0HiVeZZmuEO3XkmRyiGVC3kswIVzqPH_45pI2k7VDu4Meta } from "/home/runner/work/tensormap/tensormap/pages/referrals/index.vue?macro=true";
import { default as _91action_93fe3bjp1Hg5IR7yRzi_JZsDZZjoH95vWmW8Hod91FTycMeta } from "/home/runner/work/tensormap/tensormap/pages/signup/[action].vue?macro=true";
import { default as _91action_93n5urZsNaHsWIMi77nN4unrNj1b1ByFuXtvIfkd_45vEfMMeta } from "/home/runner/work/tensormap/tensormap/pages/surveys/[action].vue?macro=true";
import { default as terms_45of_45servicemk7zIDIjC69CmOCr6FdWvxukVxMSypPGZRfDSuEcFb0Meta } from "/home/runner/work/tensormap/tensormap/pages/terms-of-service.vue?macro=true";
import { default as _91action_93y_45YdoHu88LmHemw5TuYkJqB9NE6KZSAODQk1QpUIzJ0Meta } from "/home/runner/work/tensormap/tensormap/pages/products/[action].vue?macro=true";
import { default as indexaS3BYhLVlZ_LtBRWLCGfMbA5IPu3QzXZgsOv1CG08H4Meta } from "/home/runner/work/tensormap/tensormap/pages/transactions/index.vue?macro=true";
import { default as _91id_93HuLdvCdnpaLVJVOR0a0wMG0OfLbIfAKTQaPwg1mlI_45AMeta } from "/home/runner/work/tensormap/tensormap/pages/surveys/details/[id].vue?macro=true";
import { default as id_45backupso5sAsTO_Y_457Pl5LPFtJIyCSwaH1WVVbbW1alR9hLPwMeta } from "/home/runner/work/tensormap/tensormap/pages/surveys/details/id-backup.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexiaycEQxP4k38L0j_mwh1zNjsJEdUGVNQldVtujD_Qa4Meta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/index.vue")
  },
  {
    name: profile30kRQMklTyqvFcO2IkudJDu2EoHmi7Nxl5BcIp3Q_TQMeta?.name,
    path: "/profile",
    meta: profile30kRQMklTyqvFcO2IkudJDu2EoHmi7Nxl5BcIp3Q_TQMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/profile.vue"),
    children: [
  {
    name: "profile",
    path: "",
    meta: index8kq1bWfI4kbPXv5E0K6hXZHwx9Dlp4uw_ZRZ8V6ROXsMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/profile/index.vue")
  },
  {
    name: "profile-change-password",
    path: "change-password",
    meta: change_45passwordC1kjc8etczW91iMbQbFANh2MofAAJzFa_4547vA7lyLsAMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/profile/change-password.vue")
  }
]
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexhT5QoMrCeoupcFwmQmeHJP_GPoQ9RGVPprA1E9MQSpsMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/admin/index.vue")
  },
  {
    name: "confirm-otp",
    path: "/confirm-otp",
    meta: confirm_45otp7uwyj_45yeO2ML3w5lWqngOpPsrluaBpheuXRKxaWT6sMMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/confirm-otp.vue")
  },
  {
    name: "manage-cards",
    path: "/manage-cards",
    component: () => import("/home/runner/work/tensormap/tensormap/pages/manage-cards.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: index_45xS5sGLFdO2nZRyaocBzA5FPp_VpHoGr_E7DQDIASIgMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/signup/index.vue")
  },
  {
    name: "surveys",
    path: "/surveys",
    meta: indexaQtloG4xKf6TZf1b2ORz6V7y0mwSb3MbcvfEClihiXUMeta || {},
    alias: ["/dashboard"],
    component: () => import("/home/runner/work/tensormap/tensormap/pages/surveys/index.vue")
  },
  {
    name: "test-action",
    path: "/test/:action()",
    meta: _91action_93LrqPVpnNZ40Rx8_455m2fwfPqcoQgzmt04RydehGrjrH0Meta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/test/[action].vue")
  },
  {
    name: "admin-action",
    path: "/admin/:action()",
    component: () => import("/home/runner/work/tensormap/tensormap/pages/admin/[action].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyMRFmwy8_3clkPvcQHJOFC_Hwn1L7uQM7xOnKVUFylhgMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/privacy-policy.vue")
  },
  {
    name: "products",
    path: "/products",
    meta: indexzttKiiUSXp6G5fv1YpogKmCTePULR6U54_45RDQi_45ucDQMeta || {},
    alias: ["/products"],
    component: () => import("/home/runner/work/tensormap/tensormap/pages/products/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordM_45XYKIVuQeS5iBmTvk0djwkg1VAKKbMit3EH0pQrFEsMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/forgot-password.vue")
  },
  {
    name: "referrals",
    path: "/referrals",
    meta: indexbv0HiVeZZmuEO3XkmRyiGVC3kswIVzqPH_45pI2k7VDu4Meta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/referrals/index.vue")
  },
  {
    name: "signup-action",
    path: "/signup/:action()",
    meta: _91action_93fe3bjp1Hg5IR7yRzi_JZsDZZjoH95vWmW8Hod91FTycMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/signup/[action].vue")
  },
  {
    name: "surveys-action",
    path: "/surveys/:action()",
    meta: _91action_93n5urZsNaHsWIMi77nN4unrNj1b1ByFuXtvIfkd_45vEfMMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/surveys/[action].vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    meta: terms_45of_45servicemk7zIDIjC69CmOCr6FdWvxukVxMSypPGZRfDSuEcFb0Meta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/terms-of-service.vue")
  },
  {
    name: "products-action",
    path: "/products/:action()",
    meta: _91action_93y_45YdoHu88LmHemw5TuYkJqB9NE6KZSAODQk1QpUIzJ0Meta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/products/[action].vue")
  },
  {
    name: "transactions",
    path: "/transactions",
    meta: indexaS3BYhLVlZ_LtBRWLCGfMbA5IPu3QzXZgsOv1CG08H4Meta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/transactions/index.vue")
  },
  {
    name: "surveys-details-id",
    path: "/surveys/details/:id()",
    meta: _91id_93HuLdvCdnpaLVJVOR0a0wMG0OfLbIfAKTQaPwg1mlI_45AMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/surveys/details/[id].vue")
  },
  {
    name: "surveys-details-id-backup",
    path: "/surveys/details/id-backup",
    meta: id_45backupso5sAsTO_Y_457Pl5LPFtJIyCSwaH1WVVbbW1alR9hLPwMeta || {},
    component: () => import("/home/runner/work/tensormap/tensormap/pages/surveys/details/id-backup.vue")
  }
]